export default (state, { payload: { eventName, value } = {} }) => ({
  event: eventName,
  service_contact_method: value,
});
